module.exports = __webpack_public_path__ + "media/registry-cover_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry-cover_1600.jpg
// module id = 28
// module chunks = 0